import { render, staticRenderFns } from "./gj-upload-video.vue?vue&type=template&id=3f80ee8e&scoped=true&"
import script from "./gj-upload-video.vue?vue&type=script&lang=js&"
export * from "./gj-upload-video.vue?vue&type=script&lang=js&"
import style0 from "./gj-upload-video.vue?vue&type=style&index=0&id=3f80ee8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f80ee8e",
  null
  
)

export default component.exports